import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[cmxHeaderTemplate]',
})
export class CmxHeaderTemplateDirective {
    constructor( public template: TemplateRef<any> ) { }
}
